<template>
    <div id="newMiniFilterPreview">
        <div class="title">
            {{ filter.name }}
            {{ getValue() }}
            {{ OPERATORS_TYPES[filter.rule] }}
            <span class="material-icons" style="font-size: 16px; cursor: pointer" @click="deleteFilter"> close </span>
        </div>
        <template v-for="input of getInputs()">
            <div v-if="input.type == 'select'" style="margin-top: 3px">
                <a-select v-if="input.multiple" v-model:value="input.value" mode="multiple" style="width: 100%">
                    <a-select-option v-for="option of input.data" :key="option.key" :value="option.key">
                        {{ option.value }}
                    </a-select-option>
                </a-select>
                <a-select v-else v-model:value="input.value" style="width: 100%">
                    <a-select-option v-for="option of input.data" :key="option.key" :value="option.key">
                        {{ option.value }}
                    </a-select-option>
                </a-select>
            </div>
            <div v-else-if="input.type == 'text'" style="margin-top: 3px">
                <a-input v-model:value="input.value" style="width: 100%" />
            </div>
            <div v-else-if="input.type == 'date'" style="margin-top: 3px">
                <a-select v-model:value="input.period" style="width: 100%; margin-bottom: 5px">
                    <a-select-option :value="'today'"> Bugün </a-select-option>
                    <a-select-option :value="'yesterday'"> Dün</a-select-option>
                    <a-select-option :value="'last7'"> Bu Hafta </a-select-option>
                    <a-select-option :value="'last30'"> Son 30 Gün </a-select-option>
                    <a-select-option :value="'this-month'"> Bu Ay </a-select-option>
                    <a-select-option :value="'last-month'"> Geçen Ay </a-select-option>
                    <a-select-option :value="'custom'"> Özel </a-select-option>
                </a-select>
                <a-range-picker v-if="input.period == 'custom'" v-model:value="input.value" show-time />
            </div>
        </template>
    </div>
</template>

<script>
const OPERATORS_TYPES = {
    is: "Eşit",
    is_not: "Eşit Değil",
    contains: "İçerir",
    not_contains: "İçermez",
    starts_with: "ile Başlar",
    ends_with: "ile Biter",
};

export default {
    name: "NewMiniFilterPreview",
    props: {
        filter: {
            type: Object,
            defualt: () => {},
        },
    },
    data: () => ({
        OPERATORS_TYPES,
    }),
    methods: {
        deleteFilter() {
            this.$emit("deleteFilter");
        },
        getValue() {
            return this.filter.inputs[1]
                ? this.filter.inputs[0].data.find((d) => d.key == this.filter.inputs[0].value)?.value || ""
                : "";
        },
        getInputs() {
            return this.filter.inputs[1] ? this.filter.inputs.slice(1) : this.filter.inputs;
        },
    },
};
</script>
<style lang="scss">
#newMiniFilterPreview {
    .ant-calendar-picker {
        width: 100% !important;
    }
    .title {
        font-weight: bold;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
    }
}
</style>
